import DescriptionBulletSummaryPdpPage from "@faire/prototype-playground/workspace/wz/description-bullet-summary-pdp";
import DescriptionFormatHangfixE2ePage from "@faire/prototype-playground/workspace/wz/description-format-hangfix-e2e";
import DescriptionFormatV11NoUnicodeTitlesPage from "@faire/prototype-playground/workspace/wz/description-format-v11-no-unicode-titles";
import DescriptionFormatV1PostSqsPdpPage from "@faire/prototype-playground/workspace/wz/description-format-v1-post-sqs-pdp";
import DescriptionFormatV11PdpPage from "@faire/prototype-playground/workspace/wz/description-format-v1.1-pdp";
import DescriptionFormatV21N200Page from "@faire/prototype-playground/workspace/wz/description-format-v2-1-n200";
import DescriptionFormatV2Ab0915Page from "@faire/prototype-playground/workspace/wz/description-format-v2-ab-0915";
import DescriptionFormatV2BaselineAuditPage from "@faire/prototype-playground/workspace/wz/description-format-v2-baseline-audit";
import DescriptionFormatV2BroadPage from "@faire/prototype-playground/workspace/wz/description-format-v2-broad";
import DescriptionFormatV2CanonicalSamplePage from "@faire/prototype-playground/workspace/wz/description-format-v2-canonical-sample";
import DescriptionFormatV2CurrentPage from "@faire/prototype-playground/workspace/wz/description-format-v2-current";
import DescriptionFormatV2FinalPage from "@faire/prototype-playground/workspace/wz/description-format-v2-final";
import DescriptionFormatV2FixedPage from "@faire/prototype-playground/workspace/wz/description-format-v2-fixed";
import DescriptionFormatV2KeepPage from "@faire/prototype-playground/workspace/wz/description-format-v2-keep";
import DescriptionFormatV2LaunchPartyPage from "@faire/prototype-playground/workspace/wz/description-format-v2-launch-party";
import DescriptionFormatV2NewSchemaPage from "@faire/prototype-playground/workspace/wz/description-format-v2-newschema";
import DescriptionFormatV2NoSplitPage from "@faire/prototype-playground/workspace/wz/description-format-v2-nosplit";
import DescriptionFormatV2PdpPage from "@faire/prototype-playground/workspace/wz/description-format-v2-pdp";
import DescriptionFormatV2Pdp20260911Page from "@faire/prototype-playground/workspace/wz/description-format-v2-pdp-2026-09-11";
import DescriptionFormatV2TeamNotesPage from "@faire/prototype-playground/workspace/wz/description-format-v2-pdp-team-notes";
import DescriptionFormatV2ProdPage from "@faire/prototype-playground/workspace/wz/description-format-v2-prod";
import DescriptionFormatV2ProdFreshPage from "@faire/prototype-playground/workspace/wz/description-format-v2-prod-fresh";
import DescriptionFormatV2ProdMixedPage from "@faire/prototype-playground/workspace/wz/description-format-v2-prod-mixed";
import DescriptionFormatV2ProdMobilePdpPage from "@faire/prototype-playground/workspace/wz/description-format-v2-prod-mobile";
import DescriptionFormatV2ProductionPage from "@faire/prototype-playground/workspace/wz/description-format-v2-production";
import DescriptionFormatV2PromptsPage from "@faire/prototype-playground/workspace/wz/description-format-v2-prompts";
import DescriptionFormatV2QualitySpotcheckPage from "@faire/prototype-playground/workspace/wz/description-format-v2-quality-spotcheck";
import DescriptionFormatV2RecasePage from "@faire/prototype-playground/workspace/wz/description-format-v2-recase";
import DescriptionFormatV2RecheckPage from "@faire/prototype-playground/workspace/wz/description-format-v2-recheck";
import DescriptionFormatV2ReviewablePage from "@faire/prototype-playground/workspace/wz/description-format-v2-reviewable";
import DescriptionFormatV2SectionAccordionsPage from "@faire/prototype-playground/workspace/wz/description-format-v2-section-accordions";
import DescriptionOverviewM1AuditPage from "@faire/prototype-playground/workspace/wz/description-overview-m1-audit";
import ImageOrderingVlmPdpPage from "@faire/prototype-playground/workspace/wz/image-ordering-vlm-pdp";
import ImageOrderingVlmPdpApparel20260813Page from "@faire/prototype-playground/workspace/wz/image-ordering-vlm-pdp-apparel-2026-08-13";
import ImageOrderingVlmPdpApparelLowres20260813Page from "@faire/prototype-playground/workspace/wz/image-ordering-vlm-pdp-apparel-lowres-2026-08-13";
import ImageOrderingVlmPdpProd20260813Page from "@faire/prototype-playground/workspace/wz/image-ordering-vlm-pdp-prod-2026-08-13";
import PdpAttributeCleanupPage from "@faire/prototype-playground/workspace/wz/pdp-attribute-cleanup";
import PdpAttributeCleanupCoverageAuditPage from "@faire/prototype-playground/workspace/wz/pdp-attribute-cleanup-coverage-audit";
import PdpAttributeCleanupLlmPage from "@faire/prototype-playground/workspace/wz/pdp-attribute-cleanup-llm";
import PdpAttributeCleanupLlmHardPage from "@faire/prototype-playground/workspace/wz/pdp-attribute-cleanup-llm-hard";
import PieGenerationV2Keepers20261023Page from "@faire/prototype-playground/workspace/wz/pie-generation-v2-keepers-2026-10-23";
import PieEnrichmentSandboxPdpPage from "@faire/prototype-playground/workspace/wz/pie-enrichment-sandbox-2026-10-13";
import PieEnrichmentSandbox20261014PdpPage from "@faire/prototype-playground/workspace/wz/pie-enrichment-sandbox-2026-10-14";
import PieEnrichmentSandbox20261014Oct13PdpPage from "@faire/prototype-playground/workspace/wz/pie-enrichment-sandbox-2026-10-14-oct13";
import PiePdpBeforeAfter20261006Page from "@faire/prototype-playground/workspace/wz/pie-pdp-before-after-2026-10-06";
import PieSimilarityBandsPage from "@faire/prototype-playground/workspace/wz/pie-similarity-bands";
import PieV1VsV2AuditPage from "@faire/prototype-playground/workspace/wz/pie-v1-vs-v2-audit";
import TitleFormatSearchTilesPage from "@faire/prototype-playground/workspace/wz/title-format-search-tiles";
import VideoStartPointClipAuditPage from "@faire/prototype-playground/workspace/wz/video-start-point-clip-audit";
import { Route, Switch } from "react-router-dom";

export function WeiZhouRoutes() {
  return (
    <Switch>
      <Route
        path="/wz/pdp-attribute-cleanup-coverage-audit"
        component={PdpAttributeCleanupCoverageAuditPage}
      />
      <Route
        path="/wz/pdp-attribute-cleanup-llm-hard"
        component={PdpAttributeCleanupLlmHardPage}
      />
      <Route
        path="/wz/pdp-attribute-cleanup-llm"
        component={PdpAttributeCleanupLlmPage}
      />
      <Route
        path="/wz/pdp-attribute-cleanup"
        component={PdpAttributeCleanupPage}
      />
      <Route
        path="/wz/description-overview-m1-audit"
        component={DescriptionOverviewM1AuditPage}
      />
      <Route
        path="/wz/description-bullet-summary-pdp"
        component={DescriptionBulletSummaryPdpPage}
      />
      <Route
        path="/wz/video-start-point-clip-audit"
        component={VideoStartPointClipAuditPage}
      />
      <Route
        path="/wz/title-format-search-tiles"
        component={TitleFormatSearchTilesPage}
      />
      <Route
        path="/wz/pie-pdp-before-after-2026-10-06"
        component={PiePdpBeforeAfter20261006Page}
      />
      <Route path="/wz/pie-v1-vs-v2-audit" component={PieV1VsV2AuditPage} />
      <Route
        path="/wz/pie-generation-v2-keepers-2026-10-23"
        component={PieGenerationV2Keepers20261023Page}
      />
      <Route
        path="/wz/pie-enrichment-sandbox-2026-10-13"
        component={PieEnrichmentSandboxPdpPage}
      />
      <Route
        path="/wz/pie-enrichment-sandbox-2026-10-14"
        component={PieEnrichmentSandbox20261014PdpPage}
      />
      <Route
        path="/wz/pie-enrichment-sandbox-2026-10-14-oct13"
        component={PieEnrichmentSandbox20261014Oct13PdpPage}
      />
      <Route
        path="/wz/pie-similarity-bands"
        component={PieSimilarityBandsPage}
      />
      <Route
        path="/wz/description-format-v2-section-accordions"
        component={DescriptionFormatV2SectionAccordionsPage}
      />
      <Route
        path="/wz/description-format-v2-baseline-audit"
        component={DescriptionFormatV2BaselineAuditPage}
      />
      <Route
        path="/wz/description-format-v2-pdp-2026-09-11"
        component={DescriptionFormatV2Pdp20260911Page}
      />
      <Route
        path="/wz/description-format-v2-pdp-team-notes"
        component={DescriptionFormatV2TeamNotesPage}
      />
      <Route
        path="/wz/description-format-v2-recheck"
        component={DescriptionFormatV2RecheckPage}
      />
      <Route
        path="/wz/description-format-v2-ab-0915"
        component={DescriptionFormatV2Ab0915Page}
      />
      <Route
        path="/wz/description-format-v2-final"
        component={DescriptionFormatV2FinalPage}
      />
      <Route
        path="/wz/description-format-v2-reviewable"
        component={DescriptionFormatV2ReviewablePage}
      />
      <Route
        path="/wz/description-format-v2-canonical-sample"
        component={DescriptionFormatV2CanonicalSamplePage}
      />
      <Route
        path="/wz/description-format-v2-prod-fresh"
        component={DescriptionFormatV2ProdFreshPage}
      />
      <Route
        path="/wz/description-format-v2-prod-mixed"
        component={DescriptionFormatV2ProdMixedPage}
      />
      <Route
        path="/wz/description-format-v2-production"
        component={DescriptionFormatV2ProductionPage}
      />
      <Route
        path="/wz/description-format-v2-broad"
        component={DescriptionFormatV2BroadPage}
      />
      <Route
        path="/wz/description-format-v2-newschema"
        component={DescriptionFormatV2NewSchemaPage}
      />
      <Route
        path="/wz/description-format-v2-recase"
        component={DescriptionFormatV2RecasePage}
      />
      <Route
        path="/wz/description-format-v2-current"
        component={DescriptionFormatV2CurrentPage}
      />
      <Route
        path="/wz/description-format-v2-prompts"
        component={DescriptionFormatV2PromptsPage}
      />
      <Route
        path="/wz/description-format-v2-nosplit"
        component={DescriptionFormatV2NoSplitPage}
      />
      <Route
        path="/wz/description-format-v2-prod"
        component={DescriptionFormatV2ProdPage}
      />
      <Route
        path="/wz/description-format-v2-quality-spotcheck"
        component={DescriptionFormatV2QualitySpotcheckPage}
      />
      <Route
        path="/wz/description-format-v2-launch-party"
        component={DescriptionFormatV2LaunchPartyPage}
      />
      <Route
        path="/wz/description-format-v2-prod-mobile"
        component={DescriptionFormatV2ProdMobilePdpPage}
      />
      <Route
        path="/wz/description-format-v2-fixed"
        component={DescriptionFormatV2FixedPage}
      />
      <Route
        path="/wz/description-format-v2-keep"
        component={DescriptionFormatV2KeepPage}
      />
      <Route
        path="/wz/description-format-v1-post-sqs-pdp"
        component={DescriptionFormatV1PostSqsPdpPage}
      />
      <Route
        path="/wz/description-format-v11-no-unicode-titles"
        component={DescriptionFormatV11NoUnicodeTitlesPage}
      />
      <Route
        path="/wz/description-format-v1.1-pdp"
        component={DescriptionFormatV11PdpPage}
      />
      <Route
        path="/wz/description-format-v2-1-n200"
        component={DescriptionFormatV21N200Page}
      />
      <Route
        path="/wz/description-format-hangfix-e2e"
        component={DescriptionFormatHangfixE2ePage}
      />
      <Route
        path="/wz/description-format-v2-pdp"
        component={DescriptionFormatV2PdpPage}
      />
      <Route
        path="/wz/image-ordering-vlm-pdp-prod-2026-08-13"
        component={ImageOrderingVlmPdpProd20260813Page}
      />
      <Route
        path="/wz/image-ordering-vlm-pdp-apparel-lowres-2026-08-13"
        component={ImageOrderingVlmPdpApparelLowres20260813Page}
      />
      <Route
        path="/wz/image-ordering-vlm-pdp-apparel-2026-08-13"
        component={ImageOrderingVlmPdpApparel20260813Page}
      />
      <Route
        path="/wz/image-ordering-vlm-pdp"
        component={ImageOrderingVlmPdpPage}
      />
    </Switch>
  );
}
export const slug = "wz";
